export default {
  myCourse_compulsory: 'Mandatory',
  myCourse_elective: 'Elective',
  myCourse_web_check_course: '0402Web-View course',
  myCourse_web_show_course: '0401Web-Display my course list',
}
